import React, { Component } from 'react'
import { navbar, nav, navitem, menuitem, Dropdown, Col,Row, Button, NavDropdown,MenuItem ,Nav, NavItem} from 'react-bootstrap';
import { Router, Route, Link, IndexRoute, hashHistory, browserHistory, DefaultRoute, IndexLink } from 'react-router'

class Apropos extends Component {
  render() {
    return (
    <div>   
    	 <section id="about" className="wow fadeIn ptb ptb-sm-80">
            <div className="container filigrane">
                <div className="row text-center">
                    <div className="col-md-8 offset-md-2">
                        <h3 className="h4">Historique</h3>
                        <div className="spacer-15"></div>
                        <p>Green Agro Business a été créée en juin 2018. Cette initiative est née de la réflexion de promoteurs privés sénégalais, du soutien de l’état sénégalais via la Caisse des Dépôts et consignations et du constat qu’il faut absolument proposer au Sénégal et dans toute l’Afrique une alternative aux engrais chimiques et à la dégradation des sols depuis plusieurs décennies.</p>
                    </div>
                </div>
                <div className="row mt-80">
                  
                    <div className="col-md-6 mb-30 usine">
                        <h4>Notre usine</h4>
                        <div className="spacer-15"></div>
                        <p>Green Agro Business est l’une des rares entités de toute l’Afrique de l’Ouest à fabriquer et distribuer de l’amendement et engrais organiques destinés à tous les acteurs de la filière agricole. Nos produits sont destinés tant aux professionnels qu’aux particuliers, notamment l’engrais adapté à tout type de culture comme le riz, le gazon, les arbres fruitiers, les légumes, etc.</p>
                        <p>Cette entité se déploiera à moyen terme sur toute l’Afrique de l’Ouest avec l’implantation de nouvelles usines qui permettront de couvrir la totalité des besoins en Afrique subsaharienne.</p>
                        <p>Green Agro Business est appelée à collaborer aussi bien avec des petits producteurs locaux que de grandes exploitations agricoles en offrant un appui technique et de sensibilisation.</p>
                        <div className="spacer-15"></div>
                        <a className="btn-link-a">Lire la suite</a>
                    </div>
                 
                    <div className="col-md-6">
                        <iframe width="600" height="480" src="https://www.youtube.com/embed/vGtGSFneI7o" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                    </div>
                   
                </div>
            </div>
        </section>

    </div>
       
        

    )
  }
}
export default Apropos;


// WEBPACK FOOTER //
// ./src/components/about.jsx